<template>
  <button
    type="button"
    class="btn btn-sm btn-outline-primary"
    @click="openModal"
  >
    <FontAwesomeIcon icon="bolt" class="me-1" />
    {{ $t("production_strategy.bulk_issuance.button_text") }}
  </button>

  <BulkIssuanceModal :visible="isModalVisible" @close="closeModal" />
</template>

<script setup lang="ts">
import { ref } from "vue";
import BulkIssuanceModal from "./BulkIssuanceModal.vue";

const isModalVisible = ref(false);

const openModal = () => {
  isModalVisible.value = true;
};

const closeModal = () => {
  isModalVisible.value = false;
};
</script>
